export const testIdProp = 'data-testid';

export const getTestProps = (id: any) => ({
  [testIdProp]: id,
});
